import { render, staticRenderFns } from "./TextScroll.vue?vue&type=template&id=0cd29677&scoped=true&"
import script from "./TextScroll.vue?vue&type=script&lang=js&"
export * from "./TextScroll.vue?vue&type=script&lang=js&"
import style0 from "./TextScroll.vue?vue&type=style&index=0&id=0cd29677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd29677",
  null
  
)

export default component.exports